<template>
  <div class="px-4 py-3">
    <vetster-simple-birthday-picker
      v-model.trim="inputs.birthday_on"
      is-updating
      name="birthday"
      :pet="inputs"
      :shake="shouldShake('birthday_on', v$.inputs.birthday_on.$error)"
      :error="hasError('birthday_on', v$.inputs.birthday_on.$error)"
      :feedback="getErrorMessage('birthday_on', v$.inputs.birthday_on.$error, $t('pets.errors.please-enter-valid-pets-age'))"
    />
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { DateTime } from 'luxon';

import VetsterSimpleBirthdayPicker from '@/brand-components/VetsterSimpleBirthdayPicker';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterBirthDateForm',

  components: { VetsterSimpleBirthdayPicker },

  mixins: [ParseErrors],

  validations: {
    inputs: {
      birthday_on: {
        required,
        function(value) {
          const today = DateTime.local().startOf('day');
          const input = DateTime.fromISO(value);

          return input < today;
        },
      },
    },
  },

  props: {
    formInputs: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      inputs: { ...this.formInputs },
    };
  },

  watch: {
    inputs: {
      handler() {
        this.$emit('input', { ...this.inputs });
      },
      deep: true,
    },
  },
};
</script>
